<template>
    <div class="cpo-preview">
        <div class="cpo-preview--root" aria-hidden="true">
            <cmp-cpo-section class="cpo-preview--btn"
                    facet="preview"
                    :content="section"
                    :idx="0"
                    :is-first="true">
            </cmp-cpo-section>
            <div class="cpo-preview--overlay"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            section: Object,
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?10ab2d28